import { render, staticRenderFns } from "./List.vue?vue&type=template&id=188cc35f&scoped=true&"
import script from "./List.vue?vue&type=script&lang=ts&"
export * from "./List.vue?vue&type=script&lang=ts&"
import style1 from "./List.vue?vue&type=style&index=1&id=188cc35f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188cc35f",
  null
  
)

export default component.exports